<div
  #menuCards
  class="menu-cards"
  [ngClass]="type()">
  @for (menuItem of activeMenuItems; track menuItem) {
    <admin-app-card
      coinPermissionAccess
      [allowedResources]="$safeNavigationMigration(menuItem?.resources)"
      [allowedActions]="$safeNavigationMigration(menuItem?.actions)"
      [menuItem]="menuItem"
      [type]="type()"
      [translationPrefix]="translationPrefix()"
      (openClicked)="openClicked.emit($event)"></admin-app-card>
  }
</div>
